import type { AdminTrialItem } from './adminTrial';

export function buildTrialCustomerIdentity(trial: AdminTrialItem) {
  return {
    subscriptionId: trial.subscription_id,
    tenantId: trial.tenant_id,
    tenantName: trial.tenant_name,
    customerName: trial.customer_name,
    customerEmail: trial.customer_email,
    customerPhone: trial.customer_phone,
    country: trial.country,
    productId: trial.product_id,
    productName: trial.product_name,
    planId: trial.plan_id,
    planName: trial.plan_name,
    subscriptionStatus: trial.subscription_status,
    entitlementStatus: trial.entitlement_status,
    trialStartedAt: trial.trial_started_at,
    trialEndsAt: trial.trial_ends_at,
    daysRemaining: trial.days_remaining,
    identityLinkId: trial.identity_link_id,
    source: trial.source,
    version: trial.version,
  };
}

export type TrialCustomerIdentity = ReturnType<typeof buildTrialCustomerIdentity>;

export function hasActionableCustomerIdentity(identity: TrialCustomerIdentity): boolean {
  return Boolean(identity.customerEmail?.trim());
}
